<template>
  <button
    class="storefront-btn-blue inline-block ml-3 h-8 mb-2"
    type="button"
    aria-label="Edit this section"
    @click="onEdit"
  >
    <!-- <svg-vue icon="salesium-logo-plain" class="fill-white h-5 w-5 inline-block mr-3" /> -->
    <span class="inline-block">Edit</span>

  </button>
</template>

<script>
export default {
    methods: {
        onEdit() {
            this.$emit('Edit');
        },
    },
};
</script>